import { createFileRoute } from '@tanstack/react-router'
// eslint-disable-next-line boundaries/element-types
import { CantileverPage } from 'components/CantileverPage'
// eslint-disable-next-line boundaries/element-types
import { useNavbarData } from 'features/navbar'
import WalkdownDetails from 'pages/walkdown/WalkdownDetails'

export const Route = createFileRoute('/walkdowns/$siteID/$walkdownId')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return search
  },
})

function RouteComponent() {
  const { siteID, walkdownId } = Route.useParams()
  const { organization } = useNavbarData({ siteID })

  if (!organization) {
    return null // Or some error state
  }

  return (
    <CantileverPage>
      <WalkdownDetails
        siteID={siteID}
        walkdownId={walkdownId}
        organizationID={organization.id}
      />
    </CantileverPage>
  )
}
